import { sendFetch, sendInfoManagerFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';
import { getCompany } from '../_utils/storage_handler';
import { buildTimeStampString } from '../_utils/date_format.utils';

const BASE_PATH_INFO = '/orders-list';
const BASE_PATH = '/orders-list';

export const uploadOrdersListData = async (bytes, extension, type) => {
    let body = {
        bytes,
        extension,
        type,
        company: getCompany(),
        date_created: buildTimeStampString(new Date()),
    }
    return await sendInfoManagerFetch(`${BASE_PATH_INFO}`, POST_OPTIONS, body);
}

export const findAllOrdersList = async () => {
    return await sendFetch(`${BASE_PATH}/all/${getCompany()}`, GET_OPTIONS);
}

export const findClientOrdersList = async (client_cod) => {
    return await sendSellerFetch(`${BASE_PATH}/all/client/${getCompany()}/${client_cod}`, GET_OPTIONS);
}